import { Center } from '@astryxdesign/core/Center';
import { EmptyState } from '@astryxdesign/core/EmptyState';
import { Button } from '@astryxdesign/core/Button';

export function RouteError() {
  return (
    <Center minHeight="80dvh" padding={6}>
      <EmptyState
        title="Что-то пошло не так"
        description="Обновите страницу. Ваши записи сохранены."
        actions={<Button label="Обновить" variant="primary" onClick={() => window.location.reload()} />}
      />
    </Center>
  );
}
